import { render, staticRenderFns } from "./attributes-list.vue?vue&type=template&id=5b8349b0"
import script from "./attributes-list.vue?vue&type=script&lang=js"
export * from "./attributes-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports